import { cashFlow as AT } from './AT';
import { cashFlow as CZ } from './CZ';
import { cashFlow as HR } from './HR';
import { cashFlow as HU } from './HU';
import { cashFlow as RO } from './RO';
import { cashFlow as SK } from './SK';
import { cashFlow as RS } from './RS';

export const featureMap = {
    AT,
    CZ,
    HR,
    HU,
    RO,
    SK,
    RS,
};
